(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buddy-chew-label-check"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('buddy-ingredient-tabs')) {
    customElements.define('buddy-ingredient-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.tabsController) return;
        this.tablist = this.querySelector('[data-ingredient-tablist]');
        this.tabs = [...this.querySelectorAll('[data-ingredient-tab]')];
        this.panels = [...this.querySelectorAll('[data-ingredient-panel]')];
        if (!this.tablist || !this.tabs.length || this.tabs.length !== this.panels.length) return;
        this.tabsController = new AbortController();
        const options = { signal: this.tabsController.signal };
        this.panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[index].id);
        });
        this.activate(this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
        this.setAttribute('data-tabs-ready', '');
        this.tablist.hidden = false;
        this.tablist.addEventListener('click', event => {
          const index = this.tabs.indexOf(event.target.closest?.('[data-ingredient-tab]'));
          if (index >= 0) this.activate(index);
        }, options);
        this.tablist.addEventListener('keydown', event => {
          const index = this.tabs.indexOf(event.target.closest?.('[data-ingredient-tab]'));
          if (index < 0) return;
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.activate(next, true);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest?.('[data-ingredient-panel]');
          const index = this.panels.indexOf(panel);
          if (index >= 0) this.activate(index);
        }, options);
      }
      disconnectedCallback() {
        this.tabsController?.abort();
        this.tabsController = null;
      }
      activate(index, focus = false) {
        const activeIndex = Math.max(0, Math.min(index, this.tabs.length - 1));
        this.tabs.forEach((tab, itemIndex) => {
          const selected = itemIndex === activeIndex;
          const panel = this.panels[itemIndex];
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          panel.setAttribute('aria-hidden', String(!selected));
          panel.toggleAttribute('data-active', selected);
          panel.inert = !selected;
          panel.tabIndex = selected ? 0 : -1;
        });
        if (focus) this.tabs[activeIndex].focus();
      }
    });
  }
  if (!customElements.get('buddy-own-chew-calculator')) {
    customElements.define('buddy-own-chew-calculator', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) { this.bindDisclosure(); return; }
        this.section = this.closest('.buddy-label-school');
        this.form = this.querySelector('form');
        this.rows = this.querySelector('[data-check-rows]');
        this.rowTemplate = this.querySelector('[data-check-row-template]');
        this.weight = this.querySelector('[data-check-weight]');
        this.error = this.querySelector('[data-check-error]');
        this.result = this.querySelector('[data-check-result]');
        if (!this.section || !this.form || !this.rows || !this.rowTemplate || !this.weight) return;
        this.querySelector('[data-buddy-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(Number(this.dataset.buddyActiveMg));
        this.unit = 'g';
        this.form.addEventListener('submit', event => { event.preventDefault(); this.update(); });
        this.form.addEventListener('input', event => { if (event.target.type !== 'radio') this.update(); });
        this.form.addEventListener('change', event => {
          if (event.target.type !== 'radio') return;
          const nextUnit = event.target.value;
          const value = this.weight.valueAsNumber;
          if (nextUnit !== this.unit && Number.isFinite(value)) {
            const converted = nextUnit === 'mg' ? value * 1000 : value / 1000;
            this.weight.value = Number.isFinite(converted) ? String(Number(converted.toPrecision(12))) : '';
          }
          this.unit = nextUnit;
          this.update();
        });
        this.querySelector('[data-check-add]').addEventListener('click', () => { this.addRow({}, true); this.update(); });
        this.querySelector('[data-check-reset]').addEventListener('click', () => { this.resetFromLabel(); });
        this.resetFromLabel();
        this.hidden = false;
        this.setAttribute('data-ready', '');
        this.bindDisclosure();
      }
      disconnectedCallback() {
        this.disclosureController?.abort();
        this.disclosureController = null;
        cancelAnimationFrame(this.disclosureFrame);
      }
      bindDisclosure() {
        if (this.disclosureController) return;
        this.disclosure = this.querySelector('[data-check-disclosure]');
        if (!this.disclosure) return;
        this.disclosureController = new AbortController();
        const options = { signal: this.disclosureController.signal };
        this.disclosure.querySelector('summary').addEventListener('click', event => {
          event.preventDefault();
          this.disclosure.open = !this.disclosure.open;
        }, options);
        window.addEventListener('hashchange', () => {
          if (window.location.hash === '#chew-check') this.openFromLink();
        }, options);
        document.addEventListener('click', event => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const link = event.target.closest?.('a[href]');
          if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
          const target = new URL(link.href, window.location.href);
          if (target.origin === window.location.origin && target.pathname === window.location.pathname && target.search === window.location.search && target.hash === '#chew-check') this.openFromLink();
        }, options);
        if (window.location.hash === '#chew-check') this.openFromLink();
      }
      openFromLink() {
        this.disclosure.open = true;
        cancelAnimationFrame(this.disclosureFrame);
        this.disclosureFrame = requestAnimationFrame(() => {
          this.weight.focus({ preventScroll: true });
          this.weight.scrollIntoView({ block: 'center', behavior: 'instant' });
        });
      }
      resetFromLabel() {
        this.weight.value = this.section.querySelector('[data-example-serving]').dataset.weightG;
        this.unit = 'g';
        this.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === 'g'; });
        this.rows.replaceChildren();
        this.section.querySelectorAll('[data-example-ingredient]').forEach(row => {
          this.addRow({ name: row.querySelector('th').textContent.trim(), amount: row.dataset.amount });
        });
        this.update();
      }
      addRow(values = {}, focus = false) {
        const row = this.rowTemplate.content.firstElementChild.cloneNode(true);
        row.querySelector('[data-row-name]').value = values.name || '';
        row.querySelector('[data-row-amount]').value = values.amount ?? '';
        row.querySelector('[data-row-remove]').addEventListener('click', () => {
          const next = row.nextElementSibling || row.previousElementSibling;
          row.remove();
          this.refreshRowLabels();
          this.update();
          (next ? next.querySelector('[data-row-name]') : this.querySelector('[data-check-add]')).focus();
        });
        this.rows.append(row);
        this.refreshRowLabels();
        if (focus) row.querySelector('[data-row-name]').focus();
      }
      refreshRowLabels() {
        this.rows.querySelectorAll('[data-check-row]').forEach((row, index) => {
          const label = this.dataset.namePlaceholder.replace('__number__', String(index + 1));
          row.querySelector('[data-row-name]').placeholder = label;
          row.querySelector('[data-row-name-label]').textContent = label;
        });
      }
      calculateTotals(weight, unit, rows) {
        const servingMg = Number(weight) * (unit === 'mg' ? 1 : 1000);
        if (String(weight).trim() === '' || !Number.isFinite(servingMg) || servingMg <= 0) return { valid: false, error: 'weight' };
        const included = rows.filter(row => !row.excluded);
        if (!included.length) return { valid: false, error: 'empty' };
        if (included.some(row => String(row.amount).trim() === '' || !Number.isFinite(Number(row.amount)) || Number(row.amount) < 0)) return { valid: false, error: 'amount' };
        const total = included.reduce((sum, row) => sum + Number(row.amount), 0);
        if (!Number.isFinite(total) || total > servingMg + Number.EPSILON * Math.max(servingMg, total) * 10) return { valid: false, error: 'exceeds' };
        const count = rows.filter(row => !row.excluded || String(row.name || '').trim() !== '' || (String(row.amount).trim() !== '' && Number.isFinite(Number(row.amount)) && Number(row.amount) >= 0)).length;
        return { valid: true, count, total, servingMg, percent: Math.min(100, total / servingMg * 100), excluded: rows.length - included.length };
      }
      update() {
        const rows = [...this.rows.querySelectorAll('[data-check-row]')].map(row => {
          const amount = row.querySelector('[data-row-amount]');
          const excluded = row.querySelector('[data-row-excluded]').checked;
          const amountLabel = row.querySelector('[data-row-amount-label]');
          amountLabel.textContent = excluded ? amountLabel.dataset.countLabel : amountLabel.dataset.mgLabel;
          amount.required = !excluded;
          amount.setAttribute('aria-invalid', String(!excluded && (amount.value === '' || !Number.isFinite(amount.valueAsNumber) || amount.valueAsNumber < 0)));
          return { name: row.querySelector('[data-row-name]').value, amount: amount.value, excluded };
        });
        const result = this.calculateTotals(this.weight.value, this.unit, rows);
        this.querySelector('[data-check-excluded-note]').hidden = !rows.some(row => row.excluded);
        this.weight.setAttribute('aria-invalid', String(!result.valid && result.error === 'weight'));
        this.error.hidden = result.valid;
        this.result.hidden = !result.valid;
        this.querySelector('[data-check-buddy]').hidden = !result.valid;
        if (!result.valid) {
          this.error.textContent = this.dataset['error' + result.error[0].toUpperCase() + result.error.slice(1)];
          return;
        }
        this.error.textContent = '';
        const locale = document.documentElement.lang || 'en';
        this.querySelector('[data-check-count]').textContent = new Intl.NumberFormat(locale).format(result.count);
        this.querySelector('[data-check-total]').textContent = new Intl.NumberFormat(locale, { maximumFractionDigits: 6 }).format(result.total);
        this.querySelector('[data-check-percent]').textContent = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(result.percent) + '%';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buddy-chew-summary-findings-first"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('buddy-chew-story')) {
    customElements.define('buddy-chew-story', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-story-rail]');
        this.stage = this.querySelector('[data-story-stage]');
        this.intro = this.querySelector('[data-story-intro]');
        this.panels = Array.from(this.querySelectorAll('[data-story-panel]'));
        this.front = this.querySelector('[data-story-front]');
        this.stats = Array.from(this.querySelectorAll('[data-story-stat]'));
        this.stats.forEach(stat => { stat.dataset.final = stat.textContent; });
        this.counted = new Set();
        if (!this.rail || !this.stage || !this.front || !this.panels.length || this.controller) return;
        this.controller = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.active = -2;
        const options = { signal: this.controller.signal };
        const calculator = document.querySelector('buddy-own-chew-calculator');
        if (calculator && !calculator.id && !document.getElementById('chew-check')) calculator.id = 'chew-check';
        window.addEventListener('scroll', () => this.requestUpdate(), { ...options, passive: true });
        window.addEventListener('resize', () => this.requestMeasure(), options);
        window.visualViewport?.addEventListener('resize', () => this.requestMeasure(), options);
        this.motion.addEventListener('change', () => this.requestMeasure(), options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          if (this.hasAttribute('data-enhanced')) this.jump(index);
          else this.panels[index].scrollIntoView({ block: 'center', behavior: 'instant' });
        }, options);
        document.fonts?.ready.then(() => { if (this.isConnected) this.requestMeasure(); });
        this.measure();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.removeAttribute('data-story-pinned');
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.measureFrame);
        cancelAnimationFrame(this.countFrame);
      }
      requestMeasure() {
        if (this.measureFrame) return;
        this.measureFrame = requestAnimationFrame(() => { this.measureFrame = null; this.measure(); });
      }
      requestUpdate() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.update(); });
      }
      showAll() {
        this.finishCount();
        this.removeAttribute('data-enhanced');
        this.removeAttribute('data-story-phase');
        this.removeAttribute('data-story-pinned');
        this.rail.style.height = '';
        this.panels.forEach(panel => { panel.removeAttribute('aria-hidden'); panel.inert = false; });
        this.front.removeAttribute('aria-hidden');
        this.active = -2;
      }
      measure() {
        const header = document.querySelector('.shopify-section-header') || document.querySelector('sticky-header');
        this.top = Math.ceil(Math.min(header?.getBoundingClientRect().height || 64, 160)) + 8;
        this.style.setProperty('--story-top', this.top + 'px');
        if (this.motion.matches || this.panels.length < 2) { this.showAll(); return; }
        this.setAttribute('data-enhanced', '');
        const viewport = Math.min(window.innerHeight, window.visualViewport?.height || window.innerHeight);
        this.style.setProperty('--story-viewport', viewport + 'px');
        this.style.setProperty('--story-intro-height', Math.ceil(this.intro?.getBoundingClientRect().height || 0) + 'px');
        const height = this.stage.getBoundingClientRect().height;
        if (height > viewport - this.top - 20) { this.showAll(); return; }
        this.step = viewport * .5;
        this.rail.style.height = Math.ceil(height + this.step * this.panels.length) + 'px';
        this.active = -2;
        this.update();
      }
      update() {
        if (!this.hasAttribute('data-enhanced')) return;
        const offset = this.top - this.rail.getBoundingClientRect().top;
        this.toggleAttribute('data-story-pinned', offset >= 0 && offset <= this.step * this.panels.length);
        const position = Math.max(0, offset / this.step);
        const next = Math.min(this.panels.length - 1, Math.floor(position));
        this.reveal(next, Math.min(1, position - next));
      }
      select(index) {
        if (index === this.active) return;
        this.finishCount();
        this.active = index;
        this.setAttribute('data-topic', index < 0 ? 'front' : this.panels[index].dataset.topic);
        this.front.setAttribute('aria-hidden', String(index >= 0));
        this.panels.forEach((panel, position) => {
          const active = position === index;
          panel.toggleAttribute('data-active', active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
        });
      }
      reveal(index, phase) {
        const turn = Math.max(0, Math.min(1, (phase - .2) / .3));
        const landed = phase >= .5;
        this.select(turn >= .5 ? index : index - 1);
        this.style.setProperty('--tub-turn', ((index + turn) * 180).toFixed(3) + 'deg');
        this.front.toggleAttribute('data-face-visible', index === 0);
        this.panels.forEach((panel, position) => panel.toggleAttribute('data-face-visible', position === index || position === index - 1));
        this.setAttribute('data-story-phase', turn > 0 && turn < 1 ? 'turn' : this.active < 0 ? 'front' : 'finding');
        if (landed) this.countUp(index);
      }
      finishCount() {
        cancelAnimationFrame(this.countFrame);
        this.countFrame = null;
        this.stats.forEach(stat => { stat.textContent = stat.dataset.final; });
      }
      countUp(index) {
        const stat = this.stats[index];
        if (!stat.dataset.count || this.counted.has(index)) return;
        this.counted.add(index);
        const target = Number(stat.dataset.count);
        const start = performance.now();
        const tick = now => {
          if (!this.hasAttribute('data-enhanced') || this.active !== index) return;
          const progress = Math.min(1, (now - start) / 420);
          stat.textContent = stat.dataset.final.replace(/^\d+/, String(Math.round(target * (1 - Math.pow(1 - progress, 3)))));
          if (progress < 1) this.countFrame = requestAnimationFrame(tick);
          else this.countFrame = null;
        };
        this.countFrame = requestAnimationFrame(tick);
      }
      jump(index) {
        if (!this.hasAttribute('data-enhanced')) return;
        const target = window.scrollY + this.rail.getBoundingClientRect().top - this.top + (index + .7) * this.step;
        window.scrollTo({ top: Math.max(0, Math.ceil(target)), behavior: 'instant' });
        this.reveal(index, .7);
        this.setAttribute('data-story-pinned', '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buddy-chew-summary"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('buddy-chew-story')) {
    customElements.define('buddy-chew-story', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-story-rail]');
        this.stage = this.querySelector('[data-story-stage]');
        this.intro = this.querySelector('[data-story-intro]');
        this.panels = Array.from(this.querySelectorAll('[data-story-panel]'));
        this.front = this.querySelector('[data-story-front]');
        this.stats = Array.from(this.querySelectorAll('[data-story-stat]'));
        this.stats.forEach(stat => { stat.dataset.final = stat.textContent; });
        this.counted = new Set();
        if (!this.rail || !this.stage || !this.front || !this.panels.length || this.controller) return;
        this.controller = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.active = -2;
        const options = { signal: this.controller.signal };
        const calculator = document.querySelector('buddy-own-chew-calculator');
        if (calculator && !calculator.id && !document.getElementById('chew-check')) calculator.id = 'chew-check';
        window.addEventListener('scroll', () => this.requestUpdate(), { ...options, passive: true });
        window.addEventListener('resize', () => this.requestMeasure(), options);
        window.visualViewport?.addEventListener('resize', () => this.requestMeasure(), options);
        this.motion.addEventListener('change', () => this.requestMeasure(), options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          if (this.hasAttribute('data-enhanced')) this.jump(index);
          else this.panels[index].scrollIntoView({ block: 'center', behavior: 'instant' });
        }, options);
        document.fonts?.ready.then(() => { if (this.isConnected) this.requestMeasure(); });
        this.measure();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.removeAttribute('data-story-pinned');
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.measureFrame);
        cancelAnimationFrame(this.countFrame);
      }
      requestMeasure() {
        if (this.measureFrame) return;
        this.measureFrame = requestAnimationFrame(() => { this.measureFrame = null; this.measure(); });
      }
      requestUpdate() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.update(); });
      }
      showAll() {
        this.finishCount();
        this.removeAttribute('data-enhanced');
        this.removeAttribute('data-story-phase');
        this.removeAttribute('data-story-pinned');
        this.rail.style.height = '';
        this.panels.forEach(panel => { panel.removeAttribute('aria-hidden'); panel.inert = false; });
        this.front.removeAttribute('aria-hidden');
        this.active = -2;
      }
      measure() {
        const header = document.querySelector('.shopify-section-header') || document.querySelector('sticky-header');
        this.top = Math.ceil(Math.min(header?.getBoundingClientRect().height || 64, 160)) + 8;
        this.style.setProperty('--story-top', this.top + 'px');
        if (this.motion.matches || this.panels.length < 2) { this.showAll(); return; }
        this.setAttribute('data-enhanced', '');
        const viewport = Math.min(window.innerHeight, window.visualViewport?.height || window.innerHeight);
        this.style.setProperty('--story-viewport', viewport + 'px');
        this.style.setProperty('--story-intro-height', Math.ceil(this.intro?.getBoundingClientRect().height || 0) + 'px');
        const height = this.stage.getBoundingClientRect().height;
        if (height > viewport - this.top - 20) { this.showAll(); return; }
        this.step = viewport * .5;
        this.rail.style.height = Math.ceil(height + this.step * this.panels.length) + 'px';
        this.active = -2;
        this.update();
      }
      update() {
        if (!this.hasAttribute('data-enhanced')) return;
        const offset = this.top - this.rail.getBoundingClientRect().top;
        this.toggleAttribute('data-story-pinned', offset >= 0 && offset <= this.step * this.panels.length);
        const position = Math.max(0, offset / this.step);
        const next = Math.min(this.panels.length - 1, Math.floor(position));
        this.reveal(next, Math.min(1, position - next));
      }
      select(index) {
        if (index === this.active) return;
        this.finishCount();
        this.active = index;
        this.setAttribute('data-topic', index < 0 ? 'front' : this.panels[index].dataset.topic);
        this.front.setAttribute('aria-hidden', String(index >= 0));
        this.panels.forEach((panel, position) => {
          const active = position === index;
          panel.toggleAttribute('data-active', active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
        });
      }
      reveal(index, phase) {
        const turn = Math.max(0, Math.min(1, (phase - .2) / .3));
        const landed = phase >= .5;
        this.select(turn >= .5 ? index : index - 1);
        this.style.setProperty('--tub-turn', ((index + turn) * 180).toFixed(3) + 'deg');
        this.front.toggleAttribute('data-face-visible', index === 0);
        this.panels.forEach((panel, position) => panel.toggleAttribute('data-face-visible', position === index || position === index - 1));
        this.setAttribute('data-story-phase', turn > 0 && turn < 1 ? 'turn' : this.active < 0 ? 'front' : 'finding');
        if (landed) this.countUp(index);
      }
      finishCount() {
        cancelAnimationFrame(this.countFrame);
        this.countFrame = null;
        this.stats.forEach(stat => { stat.textContent = stat.dataset.final; });
      }
      countUp(index) {
        const stat = this.stats[index];
        if (!stat.dataset.count || this.counted.has(index)) return;
        this.counted.add(index);
        const target = Number(stat.dataset.count);
        const start = performance.now();
        const tick = now => {
          if (!this.hasAttribute('data-enhanced') || this.active !== index) return;
          const progress = Math.min(1, (now - start) / 420);
          stat.textContent = stat.dataset.final.replace(/^\d+/, String(Math.round(target * (1 - Math.pow(1 - progress, 3)))));
          if (progress < 1) this.countFrame = requestAnimationFrame(tick);
          else this.countFrame = null;
        };
        this.countFrame = requestAnimationFrame(tick);
      }
      jump(index) {
        if (!this.hasAttribute('data-enhanced')) return;
        const target = window.scrollY + this.rail.getBoundingClientRect().top - this.top + (index + .7) * this.step;
        window.scrollTo({ top: Math.max(0, Math.ceil(target)), behavior: 'instant' });
        this.reveal(index, .7);
        this.setAttribute('data-story-pinned', '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buddy-format-routine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('buddy-sachet-check')) {
    customElements.define('buddy-sachet-check', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.rotor = this.querySelector('.buddy-sachet__rotor');
        this.back = this.querySelector('.buddy-sachet__back');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.controller.signal };
        this.motion.addEventListener('change', () => this.finish(), options);
        this.queue = () => {
          if (!this.frame && !this.complete) this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        window.addEventListener('scroll', this.queue, { ...options, passive: true });
        window.addEventListener('resize', this.queue, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.finish(); }, options);
        document.addEventListener('shopify:block:select', event => {
          if (this.closest('.shopify-section')?.contains(event.target)) this.finish();
        }, options);
        this.update();
      }
      update() {
        if (this.complete) return;
        if (this.motion.matches || window.Shopify?.designMode) return this.finish();
        const rect = this.getBoundingClientRect();
        const height = window.innerHeight;
        const progress = Math.max(0, Math.min(1, (height * .94 - rect.top) / (height * .32)));
        if (progress >= 1) return this.finish();
        this.dataset.phase = progress > 0 ? 'turn' : 'front';
        this.rotor.style.transform = progress > 0 ? `rotateY(${progress * 180}deg)` : '';
        this.back.setAttribute('aria-hidden', 'true');
      }
      finish() {
        this.complete = true;
        this.dataset.phase = 'back';
        this.rotor.style.transform = '';
        this.back.removeAttribute('aria-hidden');
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buddy-trial-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('buddy-trial-results')) {
    customElements.define('buddy-trial-results', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.chart = this.querySelector('[data-trial-chart]');
        this.svg = this.chart?.querySelector('svg');
        this.tooltip = this.querySelector('[data-trial-tooltip]');
        this.announcement = this.querySelector('[data-trial-announcement]');
        this.rail = this.querySelector('[data-trial-stories]');
        this.previous = this.querySelector('[data-trial-prev]');
        this.next = this.querySelector('[data-trial-next]');
        this.points = Array.from(this.querySelectorAll('[data-trial-point]')).map(row => ({
          week: Number(row.dataset.week), score: Number(row.dataset.score), percent: Number(row.dataset.percent)
        })).sort((a, b) => a.week - b.week);
        this.min = Number(this.dataset.scoreMin);
        this.max = Number(this.dataset.scoreMax);
        this.pinned = null;
        this.animationStart = null;
        const valid = this.max > this.min && this.points.length > 1 && this.points.every((point, i, points) =>
          Number.isFinite(point.week) && Number.isFinite(point.score) && Number.isFinite(point.percent) &&
          point.score >= this.min && point.score <= this.max && point.percent >= 0 && point.percent <= 100 &&
          (i === 0 || point.week > points[i - 1].week));
        if (valid && this.chart && this.svg && this.tooltip) {
          this.chart.hidden = false;
          this.querySelector('[data-trial-table]')?.classList.add('buddy-trial-results__sr');
          this.draw();
          this.chartObserver = new ResizeObserver(() => this.draw());
          this.chartObserver.observe(this.chart);
          this.listen(this.motion, 'change', () => this.draw());
        }
        if (this.rail) {
          this.querySelector('[data-trial-controls]')?.removeAttribute('hidden');
          this.listen(this.previous, 'click', () => this.move(-1));
          this.listen(this.next, 'click', () => this.move(1));
          this.dots = Array.from(this.querySelectorAll('[data-trial-dot]'));
          this.dots.forEach((dot, index) => this.listen(dot, 'click', () => this.goTo(index)));
          this.listen(this.rail, 'scroll', () => this.updateControls());
          this.railObserver = new ResizeObserver(() => this.updateControls());
          this.railObserver.observe(this.rail);
          this.listen(this.rail, 'keydown', event => {
            if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          });
          this.listen(document, 'shopify:block:select', event => {
            const card = event.target.closest?.('[data-trial-story]');
            if (card && this.contains(card)) this.rail.scrollTo({ left: card.offsetLeft, behavior: 'instant' });
          });
          this.updateControls();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.chartObserver?.disconnect();
        this.railObserver?.disconnect();
        this.hitController?.abort();
        cancelAnimationFrame(this.frame);
      }
      listen(target, type, listener) {
        target?.addEventListener(type, listener, { signal: this.controller.signal });
      }
      draw() {
        const width = this.chart.clientWidth;
        if (!width) return;
        this.hitController?.abort();
        this.hitController = new AbortController();
        this.chart.querySelectorAll('[data-trial-hit]').forEach(element => element.remove());
        this.svg.querySelectorAll('[data-trial-drawing]').forEach(element => element.remove());
        this.tooltip.hidden = true;
        this.svg.setAttribute('viewBox', `0 0 ${width} 280`);
        const left = 48, right = width - 30, top = 8, bottom = 224;
        const firstWeek = this.points[0].week, lastWeek = this.points.at(-1).week;
        const x = week => left + (right - left) * (week - firstWeek) / (lastWeek - firstWeek);
        const yScore = value => bottom - (bottom - top) * (value - this.min) / (this.max - this.min);
        const yPercent = value => bottom - (bottom - top) * value / 100;
        const make = (tag, attributes, text) => {
          const element = document.createElementNS('http://www.w3.org/2000/svg', tag);
          element.setAttribute('data-trial-drawing', '');
          for (const [key, value] of Object.entries(attributes)) element.setAttribute(key, value);
          if (text !== undefined) element.textContent = text;
          this.svg.appendChild(element);
          return element;
        };
        for (let i = 0; i <= 5; i++) {
          const score = this.min + (this.max - this.min) * i / 5;
          const y = yScore(score);
          make('line', { x1: left, x2: right, y1: y, y2: y, stroke: 'var(--buddy-color-border-strong)', 'stroke-width': .7 });
          make('text', { x: left - 8, y: y + 4, 'text-anchor': 'end', style: 'fill:var(--trial-percent)' }, `${i * 20}%`);
          make('text', { x: right + 8, y: y + 4, style: 'fill:var(--trial-score)' }, Number(score.toFixed(1)));
        }
        const stride = Math.max(1, Math.ceil(this.points.length / Math.max(2, Math.floor((right - left) / 38))));
        this.points.forEach((point, i) => {
          if (i % stride && i !== this.points.length - 1) return;
          make('text', { x: x(point.week), y: 247, 'text-anchor': i === 0 ? 'start' : i === this.points.length - 1 ? 'end' : 'middle' }, point.week);
        });
        make('text', { x: (left + right) / 2, y: 271, 'text-anchor': 'middle' }, this.dataset.weekLabel);
        const clip = make('clipPath', { id: `${this.id}-reveal`, clipPathUnits: 'userSpaceOnUse' });
        const reveal = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        reveal.setAttribute('x', left - 6); reveal.setAttribute('y', top - 6); reveal.setAttribute('height', bottom - top + 12);
        clip.appendChild(reveal);
        for (const series of [{ key: 'score', y: yScore, color: 'var(--trial-score)' }, { key: 'percent', y: yPercent, color: 'var(--trial-percent)' }]) {
          const attributes = { 'clip-path': `url(#${this.id}-reveal)` };
          make('path', {
            d: this.points.map((point, i) => `${i ? 'L' : 'M'}${x(point.week)},${series.y(point[series.key])}`).join(' '),
            fill: 'none', stroke: series.color, 'stroke-width': 2.5, ...attributes,
            ...(series.key === 'score' ? { 'stroke-dasharray': '6 5' } : {})
          });
          this.points.forEach(point => {
            const cx = x(point.week), cy = series.y(point[series.key]);
            make(series.key === 'percent' ? 'circle' : 'rect', series.key === 'percent' ?
              { cx, cy, r: 4, fill: series.color, ...attributes } :
              { x: cx - 3.5, y: cy - 3.5, width: 7, height: 7, fill: series.color, ...attributes });
          });
        }
        this.points.forEach((point, i) => {
          make('text', {
            x: x(point.week), y: yScore(point.score) + 18,
            'text-anchor': i === 0 ? 'start' : i === this.points.length - 1 ? 'end' : 'middle',
            'clip-path': `url(#${this.id}-reveal)`,
            style: 'fill:var(--trial-score);stroke:var(--trial-background);stroke-width:4px;paint-order:stroke;stroke-linejoin:round'
          }, point.score.toFixed(1));
        });
        const guide = make('line', { x1: left, x2: left, y1: top, y2: bottom, stroke: 'currentColor', 'stroke-width': 1, visibility: 'hidden' });
        const describe = point => [
          point.week === 0 ? this.dataset.baselineLabel : `${this.dataset.weekLabel} ${point.week}`,
          `${this.dataset.scoreLabel}: ${point.score.toFixed(1)}`,
          `${this.dataset.percentLabel}: ${point.percent.toFixed(1)}%${point.week === 0 ? ` (${this.dataset.baselineNote})` : ''}`
        ];
        const show = (index, announce = false) => {
          const point = this.points[index];
          guide.setAttribute('x1', x(point.week)); guide.setAttribute('x2', x(point.week)); guide.setAttribute('visibility', 'visible');
          this.tooltip.replaceChildren();
          describe(point).forEach((text, i) => { const element = document.createElement(i === 0 ? 'strong' : 'span'); element.textContent = text; this.tooltip.appendChild(element); });
          this.tooltip.hidden = false;
          this.tooltip.style.left = `${Math.max(0, Math.min(width - this.tooltip.offsetWidth, x(point.week) - this.tooltip.offsetWidth / 2))}px`;
          this.tooltip.style.top = '38px';
          if (announce && this.announcement) this.announcement.textContent = describe(point).join('. ');
        };
        const hide = () => { if (this.pinned !== null) { show(this.pinned); return; } this.tooltip.hidden = true; guide.setAttribute('visibility', 'hidden'); };
        this.points.forEach((point, i) => {
          const hit = document.createElement('button');
          hit.type = 'button'; hit.className = 'buddy-trial-results__chart-hit'; hit.dataset.trialHit = '';
          hit.setAttribute('aria-label', describe(point).join('. '));
          const hitLeft = i === 0 ? 0 : (x(point.week) + x(this.points[i - 1].week)) / 2;
          const hitRight = i === this.points.length - 1 ? width : (x(point.week) + x(this.points[i + 1].week)) / 2;
          hit.style.left = `${hitLeft}px`; hit.style.width = `${hitRight - hitLeft}px`;
          const on = (type, listener) => hit.addEventListener(type, listener, { signal: this.hitController.signal });
          on('pointerenter', event => { if (event.pointerType !== 'touch') show(i); });
          on('pointerleave', hide); on('focus', () => show(i, true)); on('blur', hide);
          on('click', () => { this.pinned = this.pinned === i ? null : i; if (this.pinned === null) hide(); else show(i, true); });
          on('keydown', event => {
            if (event.key === 'Escape') { this.pinned = null; hide(); }
            if (['ArrowLeft', 'ArrowRight'].includes(event.key)) {
              event.preventDefault();
              const index = Math.max(0, Math.min(this.points.length - 1, i + (event.key === 'ArrowLeft' ? -1 : 1)));
              this.chart.querySelectorAll('[data-trial-hit]')[index].focus();
            }
          });
          this.chart.appendChild(hit);
        });
        if (this.pinned !== null) show(this.pinned);
        cancelAnimationFrame(this.frame);
        this.animationStart ??= performance.now();
        const animate = now => {
          const progress = this.motion.matches || this.dataset.animate !== 'true' ? 1 : Math.min(1, (now - this.animationStart) / 1300);
          reveal.setAttribute('width', (right - left + 12) * (1 - Math.pow(1 - progress, 3)));
          if (progress < 1) this.frame = requestAnimationFrame(animate);
        };
        animate(performance.now());
      }
      positions() {
        const max = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
        const cards = Array.from(this.rail.querySelectorAll('[data-trial-story]'));
        return cards.map(card => Math.min(card.offsetLeft, max)).filter((x, i, all) => i === 0 || x - all[i - 1] > 2);
      }
      goTo(index) {
        this.rail.scrollTo({ left: this.positions()[index], behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      move(direction) {
        const positions = this.positions();
        const left = this.rail.scrollLeft;
        const target = direction > 0 ? positions.find(x => x > left + 2) : positions.findLast(x => x < left - 2);
        if (target !== undefined) this.rail.scrollTo({ left: target, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      updateControls() {
        const positions = this.positions();
        const active = positions.reduce((best, x, i) => Math.abs(x - this.rail.scrollLeft) < Math.abs(positions[best] - this.rail.scrollLeft) ? i : best, 0);
        if (this.previous) this.previous.disabled = this.rail.scrollLeft < 2;
        if (this.next) this.next.disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
        this.dots?.forEach((dot, i) => {
          dot.hidden = i >= positions.length;
          dot.classList.toggle('is-active', i === active);
          dot.setAttribute('aria-current', String(i === active));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onBreakpointChangeHandler = this.onBreakpointChange.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      document.addEventListener('matchSmall', this.onBreakpointChangeHandler);
      document.addEventListener('unmatchSmall', this.onBreakpointChangeHandler);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
      requestAnimationFrame(this.updateScrolledState.bind(this));

      if (!this.useMobileScrollUpHeader() && this.dataset.scrollUp === undefined) {
        requestAnimationFrame(this.reveal.bind(this));
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      document.removeEventListener('matchSmall', this.onBreakpointChangeHandler);
      document.removeEventListener('unmatchSmall', this.onBreakpointChangeHandler);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onBreakpointChange() {
      this.preventReveal = false;

      if (!this.useMobileScrollUpHeader()) {
        if (this.dataset.scrollUp === undefined) {
          requestAnimationFrame(this.reveal.bind(this));
        }
        else {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else if ((window.pageYOffset || document.documentElement.scrollTop) <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.updateScrolledState(scrollTop);

      if (this.useMobileScrollUpHeader()) {
        const isScrollingDown = scrollTop > this.currentScrollTop;

        if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
        else if (isScrollingDown) {
          if (this.header.classList.contains('shopify-section-header-sticky')) {
            requestAnimationFrame(this.hide.bind(this));
          }
          else {
            requestAnimationFrame(this.reset.bind(this));
          }
        }
        else if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        }
        else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.dataset.scrollUp === undefined) {
        if (!this.header.classList.contains('shopify-section-header-sticky') || this.header.classList.contains('shopify-section-header-hidden')) {
          requestAnimationFrame(this.reveal.bind(this));
        }
      }
      else if (this.header.classList.contains('shopify-section-header-hidden')) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    updateScrolledState(scrollTop = window.pageYOffset || document.documentElement.scrollTop) {
      this.header.classList.toggle('shopify-section-header-scrolled', scrollTop > 0);
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    useMobileScrollUpHeader() {
      return theme.config.mqlSmall;
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
